import React from "react";

export default function TermsAndConditions() {
  return (
    <div style={styles.page}>
      <div style={styles.card}>

        <h1 style={styles.title}>Maamaas – User Terms & Conditions</h1>

        <p style={styles.updated}>Effective Date: 14th April 2026</p>

        <Section text={`Welcome to Maamaas. These Terms & Conditions govern the access and use of the Maamaas mobile application, website, and related services. By using Maamaas, you agree to be legally bound by these Terms.`} />

        <Section text={`Maamaas is a technology platform connecting users with restaurants, bakeries, cloud kitchens, banquet halls, room providers, caterers, and vendors. We do not directly own or operate third-party services.`} />

        <Title text="Eligibility" />
        <Section text={`Users must be at least 18 years old and provide accurate information. Fake or misleading accounts may be suspended or terminated.`} />

        <Title text="Account Responsibility" />
        <Section text={`Users are responsible for maintaining login credentials. Any activity under the account is the responsibility of the user.`} />

        <Title text="Information Accuracy" />
        <Section text={`Menus, prices, availability, and service details are provided by vendors. We do not guarantee 100% accuracy.`} />

        <Title text="Orders & Availability" />
        <Section text={`Orders may be accepted or rejected by vendors. Maamaas may cancel suspicious or fraudulent orders.`} />

        <Title text="User Responsibility" />
        <Section text={`Users must provide correct address and contact details. Incorrect details may result in failed delivery without refund.`} />

        <Title text="Pricing & Charges" />
        <Section text={`Prices may include delivery fees, taxes, service charges, and platform fees. Prices may change without notice.`} />

        <Title text="Payments & Refunds" />
        <Section text={`Payments are processed via secure gateways. Refunds depend on payment provider timelines.`} />

        <Title text="Cancellation Policy" />
        <Section text={`Orders cannot always be cancelled once confirmed. Cancellation charges may apply.`} />

        <Title text="Bookings" />
        <Section text={`Room, banquet, and event bookings may have separate cancellation policies and may be non-refundable.`} />

        <Title text="Delivery Timelines" />
        <Section text={`Delivery times are estimates and may vary due to traffic, weather, or operational delays.`} />

        <Title text="User Conduct" />
        <Section text={`Users must not misuse the platform, create fake orders, abuse staff, or engage in illegal activities.`} />

        <Title text="Offers & Rewards" />
        <Section text={`Discounts, promo codes, and rewards may be changed or removed at any time.`} />

        <Title text="Reviews & Content" />
        <Section text={`Users grant Maamaas rights to use reviews and feedback for marketing and operational purposes.`} />

        <Title text="Vendor Responsibility" />
        <Section text={`Vendors are responsible for food quality, hygiene, service, and order fulfillment.`} />

        <Title text="Liability Limitation" />
        <Section text={`Maamaas is not responsible for indirect damages, delays, food issues, or vendor disputes.`} />

        <Title text="Intellectual Property" />
        <Section text={`All content, branding, and software belong to Maamaas and cannot be copied without permission.`} />

        <Title text="Data & Communication" />
        <Section text={`We may collect personal data and send SMS, WhatsApp, email, and app notifications.`} />

        <Title text="Force Majeure" />
        <Section text={`We are not responsible for delays caused by natural disasters, strikes, pandemics, or system failures.`} />

        <Title text="Indemnification" />
        <Section text={`Users agree to indemnify Maamaas against claims arising from misuse of the platform.`} />

        <Title text="Jurisdiction" />
        <Section text={`All disputes will be governed by Indian law and handled in Hyderabad, Telangana courts.`} />

        <Title text="Updates to Terms" />
        <Section text={`We may update Terms anytime. Continued use means acceptance of changes.`} />

        <Title text="Contact Us" />
        <Section text={`Email: your email\nPhone: your number\nAddress: your office address`} />

        <Section text={`By using Maamaas, you agree to these Terms & Conditions.`} />

      </div>
    </div>
  );
}

/* ---------------- COMPONENTS ---------------- */

function Title({ text }) {
  return <h2 style={styles.sectionTitle}>{text}</h2>;
}

function Section({ text }) {
  return <p style={styles.text}>{text}</p>;
}

/* ---------------- STYLES (RESPONSIVE) ---------------- */

const styles = {
  page: {
    width: "100%",
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f3f4f6, #eef2f7)",
    display: "flex",
    justifyContent: "center",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
  },

  card: {
    width: "100%",
    maxWidth: "1400px",
    background: "#fff",
    borderRadius: "16px",
    padding: "clamp(18px, 3vw, 40px)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
  },

  title: {
    fontSize: "clamp(22px, 3vw, 30px)",
    fontWeight: "800",
    color: "#111",
    marginBottom: "8px",
  },

  updated: {
    fontSize: "13px",
    color: "#777",
    marginBottom: "20px",
  },

  sectionTitle: {
    fontSize: "clamp(16px, 2vw, 18px)",
    fontWeight: "700",
    marginTop: "22px",
    marginBottom: "10px",
    color: "#f97316",
    borderLeft: "4px solid #f97316",
    paddingLeft: "10px",
  },

  text: {
    fontSize: "14px",
    color: "#444",
    lineHeight: "1.7",
    marginBottom: "10px",
    whiteSpace: "pre-line",
  },
};